import { FieldBase } from './field-base'

export class CommonField<T> extends FieldBase<any> {
  [key: string]: any
  constructor(options: FieldBase<any> & {}) {
    super(options)
  }
}
